import axios from 'axios';
import * as types from "../constants";

export const getItems = () => async dispatch => {
  try {
    const res = await axios.get('/api/items/')

    dispatch({
      type: types.GET_ITEMS,
      payload: res.data
    })
  } catch (e) {
    console.error(e);
  }
}
export const selectItem = (row) => async dispatch => {
  try {
    const res = await axios.post('/api/items/getItemNotes', {query: row._id})
    row.notes = res.data

    dispatch({
      type: types.SELECT_ITEM,
      payload: row
    })
  } catch (e) {
    console.error(e);
  }

}
export const sendItemNote = (itemNote) => async dispatch => {
  try {

    const formData = new FormData();
    if(itemNote.file){
      formData.append('file', itemNote.file);
    }
    formData.append('pairedId', itemNote.pairedId);
    formData.append('note', itemNote.note);
    formData.append('dateCreated', itemNote.dateCreated);
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }
    const res = await axios.post('/api/items/upload', formData, config);

    dispatch({
      type: types.SEND_ITEM_NOTE,
      payload: res.data
    })
  } catch (e) {
    console.error(e);
  }

}
export const saveItemAttributes = (newAttributes, attributes, selectItem) => async dispatch => {
  try {
    if(newAttributes.name !== '' && newAttributes.value !== ''){
      attributes[newAttributes.name] = newAttributes.value
    }
    selectItem.attributes = attributes;
    const res = await axios.post('/api/items/updateAtributes', selectItem);
    console.log(res.data)
    dispatch({
      type: types.SAVE_ITEM_ATTRIBUTE,
      payload: res.data
    })
  } catch (e) {
    console.error();
  }
}
export const createNewItem = (data) => async dispatch => {
  let item = {
    label: '',
    attributes: {},
    category: ''
  }

  item.label = data.label;
  item.category = data.category;
  for(let i of data.attributes){
    if(i.name !== '' && i.value !== ''){
      item.attributes[i.name] = i.value
    }
  }
  try {
    if(item.label !== '' && item.category !== ''){
      let res = await axios.post('/api/items/', item)

      dispatch({
        type: types.CREATE_NEW_ITEM,
        payload: res.date
      })
    }
  } catch (e) {
    console.error(e);
  }
}

export const getReport = () => async dispatch => {
  try {
    const res = await axios.get('/api/items/getReport')

    dispatch({
      type: types.GET_REPORT,
      payload: res.data
    })
  } catch (e) {
    console.error(e);
  }
}
